import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanLeavePageGuard } from '@guards/can-leave-page.guard';

import { AccountPage } from './account.page';

const routes: Routes = [
	{
		path: '',
		component: AccountPage,
		canDeactivate: [CanLeavePageGuard]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class AccountPageRoutingModule { }
